export default __webpack_public_path__ + "static/media/eth.71931072.png";